import React from 'react'
import PropTypes from 'prop-types'
import { SettingOutlined, FileTextOutlined, ReloadOutlined, SendOutlined } from '@ant-design/icons';
import { Breadcrumb, Divider, Button } from 'antd';
import styles from './Component.css'

export default class _Header_ extends React.PureComponent {

  static propTypes = {
    onClickManageDocuments: PropTypes.func.isRequired,
    onClickSettings: PropTypes.func.isRequired,
    onClickRefresh: PropTypes.func.isRequired,
    onClickNewRun: PropTypes.func.isRequired,
  }

  render () {

    var {
      onClickManageDocuments,
      onClickSettings,
      onClickRefresh,
      onClickNewRun,
    } = this.props

    return (
      <div className={styles.wrapper}>

        <div className={styles.breadcrumbs}>
          <Breadcrumb separator="»">
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>RAMS Control Centre</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <Divider />

        <div class="_header_bar">

          <h1>RAMS Control Centre</h1>

          <Button type="primary" onClick={onClickNewRun} style={{ marginRight: 8 }}>
            <SendOutlined style={{ fontSize: 16, marginTop: 3 }} />
            New RAMS Run
          </Button>

          <Button onClick={onClickManageDocuments} style={{ marginRight: 8 }}>
            <FileTextOutlined style={{ fontSize: 16, marginTop: 3 }} />
            Manage Documents
          </Button>

          <Button onClick={onClickSettings} style={{ marginRight: 8 }}>
            <SettingOutlined style={{ fontSize: 16, marginTop: 3 }} />
            Settings
          </Button>

          <Button onClick={onClickRefresh}>
            <ReloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
            Refresh
          </Button>

        </div>

      </div>
    );
  }
}
